import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../app/providers';
import { href } from '../../app/router';
import { qk } from '../dashboard/queries';
import { usePaletteCommands } from '../palette/registry';

/**
 * The account in the editor's main menu (backlog §19 P16-3.1, the account pill is gone): profile and settings, the
 * other language (kept in the profile, as the settings page does) and sign out; members only.
 */
export function useAccountCommands(member: boolean, onNavigate: (to: string) => void): void {
  const { t, i18n } = useTranslation();
  const api = useApi();
  const queryClient = useQueryClient();
  usePaletteCommands(() => {
    if (!member) return [];
    const other = i18n.language.startsWith('fr') ? 'en' : 'fr';
    return [
      { id: 'profile', label: t('mainMenu.profile'), group: 'app', keywords: ['account', 'compte', 'settings', 'réglages'], run: () => onNavigate(href('settings')) },
      {
        id: 'language',
        label: t('lang.switch'),
        group: 'app',
        keywords: ['language', 'langue'],
        run: async () => {
          await api.updateProfile({ locale: other });
          await queryClient.invalidateQueries({ queryKey: qk.profile });
          await i18n.changeLanguage(other);
        },
      },
      { id: 'signOut', label: t('auth.signOut'), group: 'app', keywords: ['logout', 'déconnexion'], run: () => void api.auth.signOut() },
    ];
  });
}
